import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { APP_URLS } from '../../../providers/constant';

@Injectable({
  providedIn: 'root'
})
export class MyProfileService {

  private demoApiUrl = `${APP_URLS.DEMO_API_URL}`;

  constructor(private http: HttpClient) { }

  public getUserDataByUserCode(userCode: any, appCode: any): Observable<any> {
    return this.http.get<any>(`${this.demoApiUrl}/user_information.php?userCode=${userCode}&appCodes=${appCode}`);
  }

  public updateMyProfile(myProfileObject: any): Observable<any> {
    return this.http.post<any>(`${this.demoApiUrl}/user_information.php`, myProfileObject);
  }

}
